import { ApplicationSettings } from './application_settings.model';
import { AWSSettings } from './aws_settings.model';

export class ApplicationFeatures {
  static featureMap: any = {
    'events': { system_name: 'events', display_name: 'Calendar' },
    'pods': { system_name: 'pods', display_name: 'Home Screen' },
    'push-notifications': { system_name: 'push-notifications', display_name: 'Push Notifications' },
    'nav-items': { system_name: 'nav-items', display_name: 'Navigation Menu' },
    'pages': { system_name: 'pages', display_name: 'App Content' },
    'messages': { system_name: 'messages', display_name: 'Messages' },
    'ibeacons': { system_name: 'ibeacons', display_name: 'iBeacons' },
    'training': { system_name: 'training', display_name: 'Training' },
    'ads': { system_name: 'ads', display_name: 'Promotions' }, // deprecated
    'promotions': { system_name: 'ads', display_name: 'Promotions' }
  }
}

// Application initially has only URL and system name
export class Application {
  id: number = null;
  logo: string;
  sys_name: string;
  full_name: string = '';
  settings: ApplicationSettings;
  aws: AWSSettings;
  features: any[] = [];
  permissions: string[] = [];
  primaryColor: string = '';
  secondaryColor: string = '';
  tertiaryColor: string = '';
  numUsers: number = 0;
  projectStatus: string = 'initial-setup';
  projectNotes: string = '';
  isActive: boolean = true;

  testID: string = '';

  constructor(json?: any) {
    if (!json) return;
    // console.log(json);
    this.id = json.id || json.app_id || null;
    this.sys_name = json.app || json.sys_name || '';
    if (json) {
      if (json.settings && json.settings.app_name) {
        this.full_name = json.settings.app_name;
      }
      this.numUsers = json.number_of_users || 0;
      this.projectStatus = json.status || 'not-started';
      this.projectNotes = json.status_notes || '';
      this.isActive = json.is_active;
    }

    this.addDetails(json);

    if (json.aws) {
      this.aws = new AWSSettings(json.aws);
    }

    this.generateDynamicId();
  }

  get fullName() {
    return this.full_name.length ? this.full_name : this.sys_name;
  }

  generateDynamicId() {
    let validId = this.sys_name;
    validId = validId.replace(/\s/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z0-9]+/gi, '');
    this.testID = 'app-' + validId;
  }

  hasUserPermission(permission: string) {
    return this.permissions.indexOf(permission) > -1;
  }

  hasFeature(featureSysName: string) : boolean {
    if (!this.features.length) return false;
    return this.features.filter(feature =>
      feature.system_name &&
      feature.system_name.toLowerCase() === featureSysName.toLowerCase()).length > 0;
  }

  addDetails(json?: any) {
    if (!(json)) return; // This is used to create an empty application obj, as used in application-create CC
    this.logo = json.logo;
    this.settings = (json.settings ? new ApplicationSettings(json.settings) : null);

    let permissions = json.permissions;
    if (permissions) {
      this.permissions = json.permissions;
      if (permissions && permissions.indexOf('pages') === -1) this.features.push(ApplicationFeatures.featureMap['pages']);
      for (var i = 0; i < permissions.length; i++) {
        let feature = ApplicationFeatures.featureMap[permissions[i]];
        if (feature) this.features.push(ApplicationFeatures.featureMap[permissions[i]]);
      }
    }

    this.features.sort((a, b) => {
      return a.display_name.localeCompare(b.display_name);
    })
  }

  addMobileDetails(json?: any) {
    if (json.primary_color) this.primaryColor = json.primary_color;
    if (json.secondary_color) this.secondaryColor = json.secondary_color;
    if (json.tertiary_color) this.tertiaryColor = json.tertiary_color;
  }

  get navRoot() : string {
    return '/app/' + this.sys_name;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/application/application.model.ts